// @flow

import { combineReducers } from "redux"
import { routerReducer } from "react-router-redux"
import { reducer as toastr } from "react-redux-toastr"
import auth from "./auth"
import suggestions from "./suggestions"
import rehydrate from "./rehydrate"
import search from "./search"
import user from "./user"
import procedure from "./procedure"
import getProcedure from "./getProcedure"
import getDebt from "./getDebt"
import paymentAgreements from "./paymentAgreements"
import paymentAgreementById from "./paymentAgreementById"
import jobs from "./jobs"
import imports from "./imports"
import systemUsers from "./systemUsers"
import systemGroups from "./systemGroups"
import contactHistory from "./contactHistory"
import interestTypes from "./interestTypes"
import expenses from "./expenses"
import billingOrders from "./billingOrders"

export default combineReducers( {
  rehydrate,
  suggestions,
  user,
  search,
  auth,
  procedure,
  getProcedure,
  getDebt,
  paymentAgreements,
  paymentAgreementById,
  routing: routerReducer,
  toastr,
  jobs,
  imports,
  systemUsers,
  systemGroups,
  contactHistory,
  interestTypes,
  expenses,
  billingOrders,
} )



// WEBPACK FOOTER //
// ./src/reducers/index.jsx